
export function getSyncedTimestampSec() {
  let offsetMs = Number(localStorage.getItem("serverTimeOffsetMs") || 0);
  return Math.floor(offsetMs / 1000);
}

export function updateOffsetFromResponse(res) {
  const serverMs = Number(res?.headers?.["x-server-time"]);
  if (!serverMs) return;

  localStorage.setItem("serverTimeOffsetMs", String(serverMs));
}